export default ({ request }) => ({
  ecomOverseasInvSkuSetListApi(data = {}) {
    return request({
      url: '/ecomorder/overseas/inv/sku/set/list',
      method: 'post',
      data,
    })
  },
  ecomOverseasInvSkuSetDetailApi(data = {}) {
    return request({
      url: '/ecomorder/overseas/inv/sku/set/detail',
      method: 'post',
      data,
    })
  },
  ecomOverseasInvSkuSetDelApi(data = {}) {
    return request({
      url: '/ecomorder/overseas/inv/sku/set/del',
      method: 'post',
      data,
    })
  },
  ecomOverseasInvSkuSetSyncLcApi(data = {}) {
    return request({
      url: '/ecomorder/overseas/inv/sku/set/sync/lc',
      method: 'post',
      data,
    })
  },
  ecomOverseasInvSkuSetAddApi(data = {}) {
    return request({
      url: '/ecomorder/overseas/inv/sku/set/add',
      method: 'post',
      data,
    })
  },
  ecomOverseasInvSkuSetEditorApi(data = {}) {
    return request({
      url: '/ecomorder/overseas/inv/sku/set/editor',
      method: 'post',
      data,
    })
  },
  ecomOverseasInvSkuSetDeactivateApi(data = {}) {
    return request({
      url: '/ecomorder/overseas/inv/sku/set/deactivate',
      method: 'post',
      data,
    })
  },
  ecomOverseasInvSkuSetRestorationApi(data = {}) {
    return request({
      url: '/ecomorder/overseas/inv/sku/set/restoration',
      method: 'post',
      data,
    })
  },
  ecomOverseasInvSkuSetAvailableApi(data = {}) {
    return request({
      url: '/ecomorder/overseas/inv/sku/set/available',
      method: 'post',
      data,
    })
  },
  ecomOverseasInvPushApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/overseas/inv/push',
      method: 'post',
      data,
    })
  },
})
